import React from 'react';
import { StyledQuote } from './Quote.style';

const Quote = ({ text }) => <StyledQuote>{text}</StyledQuote>;

export default Quote;
